module.exports = require("@finance/sui/lib/components/Toast/style.css");